import React from "react";
import { connect } from "react-redux";
import {
    List as ListIcon,
    LocationOn as MapIcon,
    Close as CloseIcon,
} from "@material-ui/icons";
import { Typography, IconButton, Tooltip } from "@material-ui/core";
import {
    selectQR,
    getRequesting,
    selectAllEquipmentTypes,
    canUpdate,
    canCreate,
    canDelete,
    selectDepartments,
    selectAreas,
    selectEquipmentType,
    expirySelectQR,
    selectEquFilter,
    selectCategories,
    selectCategoryTitles
} from "./selectors";
import ReactToPrint from "react-to-print";
import TemplateWrapper from "../../Utilities/TemplateWrappers/PageTemplate";
import PrintIcon from "@material-ui/icons/EventBusy";
import CropFreeIcon from "@material-ui/icons/CropFree";
import {
    Row,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    Spinner,
    ModalHeader,
} from "reactstrap";
import {
    getQR,
    setQR,
    uploadFile,
    removeQr,
    updateCatagories,
    getEquipmentTypes,
    setFilterEquipmentType,
    removeImage,
    setEquFilter,
    getCategories,
    submitNewCategory,
    setQRData
} from "./actions";

import {
    AddEditModal,
    QRTable,
    RemoveModal,
    ViewQRModal,
    LocationModal,
    ViewAttachedFiles,
    ChangeCatagoryModal,
    ViewEquipmentModal,
} from "./Components";

import blankProfile from "./QRProfile";
import { Button, TableRow } from "@material-ui/core";
import MapContainer from "./MapContainer";
//import { StyledViewContainer } from "../../styles";
//import { Divider } from "@material-ui/core";
import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";

class QRList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addEditModalState: false,
            addEditModalType: "add",
            qrProfile: blankProfile,
            qrUID: false,
            removeModalState: false,
            viewQRModalState: false,
            locationModalState: false,
            pageView: "list",
            viewAttachedFileState: false,
            allQrData: false,
            expiryQrData: false,
            selectedQRs: [],
            viewEquipmentModalState: false,
        };
        props.getQR();
        props.getEquipmentTypes();
        props.getCategories();
    }
    handleCloseGroupModal = () => {
        this.setState({ allQrData: false, expiryQrData: false });
    };

    render() {
        const {
            qrs,
            equipmentTypes,
            setFilterEquipmentType,
            selectedEquipmentType,
            expiryEquipment,
        } = this.props;
        const { pageView } = this.state;
        return (
            <TemplateWrapper
                label=" Equipment Manager"
                PageActions={
                    <>
                        <IconButton
                            value="map"
                            variant="contained"
                            size="small"
                            style={{
                                float: "right",
                                color: "white",
                                border:
                                    this.state.pageView === "map"
                                        ? "1px solid white"
                                        : "0px solid white",
                            }}
                            onClick={(e) => {
                                this.setState({
                                    pageView: "map",
                                });
                            }}
                        >
                            {" "}
                            <MapIcon />
                        </IconButton>
                        <IconButton
                            value="list"
                            variant="contained"
                            size="small"
                            style={{
                                float: "right",
                                color: "white",
                                border:
                                    this.state.pageView === "list"
                                        ? "1px solid white"
                                        : "0px solid white",
                            }}
                            onClick={(e) => {
                                this.setState({
                                    pageView: "list",
                                });
                            }}
                        >
                            <ListIcon />
                        </IconButton>
                        <Tooltip title="Print All QR Codes">
                            <CropFreeIcon
                                style={{
                                    float: "right",
                                    margin: 5,
                                    cursor: "pointer",
                                    color: "white",
                                }}
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.setState({
                                        allQrData: true,
                                    });
                                }}
                            />
                        </Tooltip>

                        <Tooltip title="Print Expired Equipment">
                            <PrintIcon
                                style={{
                                    float: "right",
                                    margin: 5,
                                    cursor: "pointer",
                                    color: "white",
                                }}
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.setState({
                                        expiryQrData: true,
                                    });
                                }}
                            />
                        </Tooltip>
                    </>
                }
            >
                <Modal
                    isOpen={this.props.requesting}
                    style={{ maxWidth: "00px" }}
                >
                    <ModalBody>
                        <div
                            style={{
                                textAlign: "center",
                                paddingTop: "3em",
                            }}
                        >
                            <div
                                style={{
                                    background: "white",
                                    width: "fit-content",
                                    display: "inline-block",
                                    padding: "2em",
                                }}
                            >
                                <Spinner
                                    style={{
                                        height: 100,
                                        width: 100,
                                        background: "white",
                                    }}
                                    color="primary"
                                />
                                <Typography
                                    style={{
                                        textAlign: "center",
                                        marginTop: 15,
                                        color: "rgba(0, 0, 0, 0.87)",
                                        fontWeight: "bolder",
                                        fontSize: 20,
                                    }}
                                    variant="body2"
                                >
                                    Processing...
                                </Typography>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.allQrData}>
                    <ModalHeader>
                        Print All QR Data
                        <CloseIcon
                            style={{
                                color: "black",
                                position: "absolute",
                                top: 20,
                                right: 20,
                                float: "right",
                                cursor: "pointer",
                            }}
                            onClick={this.handleCloseGroupModal}
                        />
                    </ModalHeader>

                    <ModalBody>
                        <div ref={(el) => (this.componentRef = el)}>
                            <Row>
                                {qrs &&
                                    qrs.map((qr, i) => {
                                        return (
                                            <>
                                                <p>
                                                    <TableRow>
                                                        <img
                                                            alt="qrcode"
                                                            style={{
                                                                height: 200,
                                                                width: 200,
                                                            }}
                                                            src={qr.qr_code_url}
                                                        />
                                                    </TableRow>
                                                </p>

                                                <Col
                                                    style={{
                                                        marginTop: "56px",
                                                    }}
                                                >
                                                    <b>Name:</b>
                                                    {qr.name} <br />
                                                    <b>Status:</b>
                                                    {qr.status} <br />
                                                    <b>Category:</b>
                                                    {qr.category} <br />
                                                    <b>Serviced On:</b>
                                                    {qr.date_last_service}{" "}
                                                    <br />
                                                </Col>
                                            </>
                                        );
                                    })}
                            </Row>
                        </div>
                    </ModalBody>

                    <ModalFooter>
                        <ReactToPrint
                            trigger={() => (
                                <Button variant="contained" color="primary">
                                    Print
                                </Button>
                            )}
                            content={() => this.componentRef}
                        />
                        <div>
                            <Button onClick={this.handleCloseGroupModal}>
                                Close
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.expiryQrData}>
                    <ModalHeader>
                        Print Close To Expire Equipments
                        <CloseIcon
                            style={{
                                color: "black",
                                position: "absolute",
                                top: 20,
                                right: 20,
                                float: "right",
                                cursor: "pointer",
                            }}
                            onClick={this.handleCloseGroupModal}
                        />
                    </ModalHeader>

                    <ModalBody>
                        <div ref={(el) => (this.componentRef1 = el)}>
                            <Row>
                                {expiryEquipment &&
                                    expiryEquipment.map((qr, i) => {
                                        return (
                                            <>
                                                <p>
                                                    <TableRow>
                                                        <img
                                                            alt="qrcode"
                                                            style={{
                                                                height: 200,
                                                                width: 200,
                                                            }}
                                                            src={qr.qr_code_url}
                                                        />
                                                    </TableRow>
                                                </p>

                                                <Col
                                                    style={{
                                                        marginTop: "56px",
                                                    }}
                                                >
                                                    <b>Name:</b>
                                                    {qr.name} <br />
                                                    <b>Status:</b>
                                                    {qr.status} <br />
                                                    <b>Category:</b>
                                                    {qr.category} <br />
                                                    <b>Serviced On:</b>
                                                    {qr.date_last_service}{" "}
                                                    <br />
                                                </Col>
                                            </>
                                        );
                                    })}
                            </Row>
                        </div>
                    </ModalBody>

                    <ModalFooter>
                        <ReactToPrint
                            trigger={() => (
                                <Button variant="contained" color="primary">
                                    Print
                                </Button>
                            )}
                            content={() => this.componentRef1}
                        />
                        <div>
                            <Button onClick={this.handleCloseGroupModal}>
                                Close
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>

                {pageView === "list" && qrs && (
                    <QRTable
                        qrs={qrs}
                        setViewModal={(qrUID, qrProfile) =>
                            this.setState({
                                viewEquipmentModalState: true,
                                qrUID,
                                qrProfile,
                            })
                        }
                        setAddEditModal={(type, qrProfile, qrUID) =>
                            this.setState({
                                addEditModalState: true,
                                addEditModalType: type,
                                qrProfile,
                                qrUID,
                            })
                        }
                        setRemoveModal={(qrUID, qrProfile) =>
                            this.setState({
                                removeModalState: true,
                                qrUID,
                                qrProfile,
                            })
                        }
                        setViewQRModal={(qrUID, qrProfile) =>
                            this.setState({
                                viewQRModalState: true,
                                qrUID,
                                qrProfile,
                            })
                        }
                        setAttachedFileModal={(qrUID, qrProfile) =>
                            this.setState({
                                viewAttachedFileState: true,
                                qrUID,
                                qrProfile,
                            })
                        }
                        setChangeCatagoryModal={(uids) => {
                            this.setState({
                                changeCatagoryModal: true,
                                selectedQRs: uids,
                            });
                        }}
                        setLocationModal={(qrUID, qrProfile) =>
                            this.setState({
                                locationModalState: true,
                                qrUID,
                                qrProfile,
                            })
                        }
                        categories={this.props.categories}
                        canDelete={this.props.canDelete}
                        canUpdate={this.props.canUpdate}
                        equType={selectedEquipmentType}
                        setEquipmentType={setFilterEquipmentType}
                        equipmentTypes={equipmentTypes}
                        setEquFilter={this.props.setEquFilter}
                        equFilter={this.props.equFilter}
                        tempTitles={this.props.tempTitles}
                        submitNewCategory={this.props.submitNewCategory}
                        setQRData={this.props.setQRData}
                    />
                )}
                {pageView === "map" && <MapContainer qrs={qrs} />}

                <AddEditModal
                    isOpen={this.state.addEditModalState}
                    type={this.state.addEditModalType}
                    qr={this.state.qrProfile}
                    qrUID={this.state.qrUID}
                    close={() => this.setState({ addEditModalState: false })}
                    setQR={this.props.setQR}
                    equipmentTypes={this.props.equipmentTypes}
                    areas={this.props.areas}
                    departments={this.props.departments}
                    uploadFile={this.props.uploadFile}
                    removeImage={this.props.removeImage}
                    requesting={this.props.requesting}
                />
                <ChangeCatagoryModal
                    isOpen={this.state.changeCatagoryModal}
                    type={this.state.addEditModalType}
                    qr={this.state.qrProfile}
                    qrUID={this.state.qrUID}
                    selectedQRs={this.state.selectedQRs}
                    close={() => this.setState({ changeCatagoryModal: false })}
                    catagories={this.props.equipmentTypes}
                    areas={this.props.areas}
                    departments={this.props.departments}
                    updateCatagory={this.props.updateCatagories}
                />
                <RemoveModal
                    isOpen={this.state.removeModalState}
                    qr={this.state.qrProfile}
                    qrUID={this.state.qrUID}
                    close={() => this.setState({ removeModalState: false })}
                    removeQr={this.props.removeQr}
                    setActivity={this.props.setActivity}
                />
                <ViewQRModal
                    isOpen={this.state.viewQRModalState}
                    qr={this.state.qrProfile}
                    qrUID={this.state.qrUID}
                    close={() => this.setState({ viewQRModalState: false })}
                    //getQR={this.props.getQR}
                />
                <LocationModal
                    isOpen={this.state.locationModalState}
                    qr={this.state.qrProfile}
                    qrUID={this.state.qrUID}
                    close={() => this.setState({ locationModalState: false })}
                    getQR={this.props.getQR}
                />
                <ViewAttachedFiles
                    isOpen={this.state.viewAttachedFileState}
                    qr={this.state.qrProfile}
                    qrUID={this.state.qrUID}
                    close={() =>
                        this.setState({
                            viewAttachedFileState: false,
                        })
                    }
                />
                <ViewEquipmentModal
                    isOpen={this.state.viewEquipmentModalState}
                    qr={this.state.qrProfile}
                    allInfo={qrs}
                    close={() =>
                        this.setState({
                            viewEquipmentModalState: false,
                        })
                    }
                />
            </TemplateWrapper>
        );
    }
}

export default connect(
    (store) => {
        return {
            qrs: selectQR(store),
            requesting: getRequesting(store),
            equipmentTypes: selectAllEquipmentTypes(store),
            selectedEquipmentType: selectEquipmentType(store),
            canUpdate: canUpdate(store),
            canCreate: canCreate(store),
            canDelete: canDelete(store),
            departments: selectDepartments(store),
            areas: selectAreas(store),
            expiryEquipment: expirySelectQR(store),
            equFilter: selectEquFilter(store),
            categories: selectCategories(store),
            tempTitles: selectCategoryTitles(store),
        };
    },

    {
        getQR,
        setQR,
        setQRData,
        uploadFile,
        removeQr,
        getEquipmentTypes,
        updateCatagories,
        setFilterEquipmentType,
        removeImage,
        setEquFilter,
        setActivity,
        getCategories,
        submitNewCategory
    }
)(QRList);
